module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/search-0f602a215a9ffedb491b68d888bbe894.svg";